import logger from '@eventbrite/client-logger';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { ApplePayWithMerchantIdentifier } from '../actions/applePay';

/**
 * @WARNING This will throw an error in Safari on organizer sites.
 */
export const isApplePaySupported = () => {
    try {
        return (
            HAS_WINDOW &&
            window.ApplePaySession?.supportsVersion(3) &&
            window.ApplePaySession?.canMakePayments()
        );
    } catch (e) {
        logger.error(e);
        return false;
    }
};

/**
 * @WARNING This will throw an error in Safari on organizer sites.
 */
export const isApplePayCardActive = async (
    applePayInstance: ApplePayWithMerchantIdentifier,
) => {
    try {
        return (
            isApplePaySupported() &&
            (await window.ApplePaySession?.canMakePaymentsWithActiveCard(
                applePayInstance.merchantIdentifier,
            ))
        );
    } catch (e) {
        logger.error(e);
        return false;
    }
};
